export default {"src":"/_next/static/media/remove.aa814ed6.svg","height":10,"width":10};